'use client'

import Image from 'next/image'
import { type ReactNode, useEffect, useState } from 'react'

import { getBuilderPreviewMode } from '@src/utils/builder.util'
import { getIsServer } from '@src/utils/common.util'

interface Props {
  smartTagId?: string
  attributes?: any
  className?: string
  renderLoading?: ReactNode
}

export function Digioh({ smartTagId, attributes, className, renderLoading }: Props) {
  const [isDigiohReady, setDigiohReady] = useState(false)
  const { edit } = getBuilderPreviewMode()

  useEffect(() => {
    if (getIsServer()) return

    const interval = setInterval(() => {
      if (window.DIGIOH_API?.LIGHTBOX?.isDigiohReady()) {
        setDigiohReady(true)
        clearInterval(interval)
      }
    }, 100)

    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    if (!isDigiohReady || getIsServer()) return
    window.DIGIOH_API.LIGHTBOX.loadLightbox(smartTagId)
  }, [isDigiohReady, smartTagId])

  if (edit) {
    return (
      <Image
        src="/images/digioh_logo.jpeg"
        height={60}
        width={60}
        alt="digioh_img"
        {...attributes}
      />
    )
  }
  return (
    <div id={smartTagId} className={className}>
      {!isDigiohReady && renderLoading}
    </div>
  )
}
